import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { Order, OrderFinancialStatus, OrderLineItem } from 'src/app/shop/models/order.model';

@Component({
    selector: 'app-order-list-item',
    templateUrl: './order-list-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderListItemComponent {
  @Input() order!: Order;
  private dict = new FromDictionaryPipe(this.lang);

  constructor(private lang: LanguageService) {}

  getLabel(suffix: string, label: string) {
    const dictPlaceholder = suffix + label;
    if (this.dict.transform(dictPlaceholder, false)) {
      return this.dict.transform(dictPlaceholder, false);
    }
    console.warn('CMS dictionary: Label not filled for placeholder:', dictPlaceholder);
    return label;
  }
}
